import { config } from 'utils/config';
import { FeatureFlagEnum } from '../enums/feature-flag.enum';

export const isFeatureEnabled = (feature: FeatureFlagEnum | `${FeatureFlagEnum}`) => {
  return config.env[`VITE_FEATURE_FLAG_${feature}`] === 'true';
};
